import * as React from 'react';
export const uploadSvg = React.forwardRef(function uploadSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2 8.75a.75.75 0 0 1 .75.75V14h10.5V9.5a.75.75 0 0 1 1.5 0v5.25a.75.75 0 0 1-.75.75H2a.75.75 0 0 1-.75-.75V9.5A.75.75 0 0 1 2 8.75Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8.53.47a.748.748 0 0 0-1.06 0l-3.5 3.5a.75.75 0 0 0 1.06 1.06l2.22-2.22v8.69a.75.75 0 0 0 1.5 0V2.81l2.22 2.22a.75.75 0 1 0 1.06-1.06L8.53.47Z',
    }),
  );
});
uploadSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var upload = {
  category: 'icon',
  colorable: true,
  name: 'upload',
  svg: uploadSvg,
};
